import { h } from 'preact';
import * as BaseComp from 'components/bolt/hub/components/heroCarousel/heroCarousel.js';
// import s from 'components/bolt/hub/components/heroCarousel/heroCarousel.sss';

export default class HeroCarousel extends BaseComp.default {
	startIterating() {
		const { interval = 8000 } = this.props;
		this.interval = window.setInterval(() => {
			this.iterate(1);
		}, interval);
	}
}
